import Scroll from '../helpers/scroll';

const selectors = {
  stickyHeader: '[sticky-header]',
};

export default class StickyHeader {
  constructor() {
    this.el = document.querySelector(selectors.stickyHeader);

    this.listener = new Scroll(this.onScroll, this.el);
    this.el.className += ' sticky top-0 z-50 bg-sand transition-transform';
  }

  onScroll = direction => {
    if (direction === 'up') {
      this.showMenu();
    } else if (direction === 'down') {
      this.hideMenu();
    }
  };

  showMenu = () => {
    this.el.classList.remove('-translate-y-full');
    this.el.classList.add('-translate-y-0');
  };

  hideMenu = () => {
    this.el.classList.add('-translate-y-full');
    this.el.classList.remove('-translate-y-0');
  };
}
